import { RasterTypeEnum } from "@nens/threedi/openapi-client";

export type RdcRasterStyleStop = {
  value: number;
  color: string;
};

export type RdcRasterStyle = {
  range: [number, number] | undefined;
  stops: RdcRasterStyleStop[];
};

// Generated from threedi-schematisation-editor raster QML styles.
// https://github.com/nens/threedi-schematisation-editor/tree/master/threedi_schematisation_editor/styles/raster
// FUTURE: This will at some point be provided by the backend, so we don't have to hardcode it here. For now, this is a good starting point for styling rasters in the frontend.
export const RDC_RASTER_STYLE_BY_TYPE: Partial<Record<RasterTypeEnum, RdcRasterStyle>> = {
  [RasterTypeEnum.DEM_FILE]: {
    range: [120.2900009, 276.8599854],
    stops: [
      {
        value: 120.29000091553,
        color: "#018571",
      },
      {
        value: 137.68666585286667,
        color: "#39a595",
      },
      {
        value: 155.08333079020332,
        color: "#72c5b8",
      },
      {
        value: 172.47999572754,
        color: "#a7dad2",
      },
      {
        value: 189.87666066487668,
        color: "#dbece9",
      },
      {
        value: 207.27332560221333,
        color: "#f0eada",
      },
      {
        value: 224.66999053954999,
        color: "#e6d3a5",
      },
      {
        value: 242.06665547688667,
        color: "#d9b772",
      },
      {
        value: 259.46332041422335,
        color: "#bf8c46",
      },
      {
        value: 276.85998535156,
        color: "#a6611a",
      },
    ],
  },
  [RasterTypeEnum.FRICT_COEF_FILE]: {
    range: [0, 0.058],
    stops: [
      {
        value: 0,
        color: "#440154",
      },
      {
        value: 0.00644444425900777,
        color: "#472778",
      },
      {
        value: 0.0128888885180155,
        color: "#3e4a89",
      },
      {
        value: 0.0193333327770233,
        color: "#31688d",
      },
      {
        value: 0.0257777770360311,
        color: "#26838d",
      },
      {
        value: 0.0322222212950389,
        color: "#229d88",
      },
      {
        value: 0.0386666655540466,
        color: "#38b777",
      },
      {
        value: 0.0451111098130544,
        color: "#6ece58",
      },
      {
        value: 0.0515555540720622,
        color: "#b5de2b",
      },
      {
        value: 0.0579999983310699,
        color: "#fde725",
      },
    ],
  },
  [RasterTypeEnum.INFILTRATION_RATE_FILE]: {
    range: [0, 1032],
    stops: [
      {
        value: 0,
        color: "#f0f9e8",
      },
      {
        value: 114.66666666666667,
        color: "#d8f0d5",
      },
      {
        value: 229.33333333333334,
        color: "#c0e7c1",
      },
      {
        value: 344,
        color: "#a5dcbf",
      },
      {
        value: 458.6666666666667,
        color: "#89d2c2",
      },
      {
        value: 573.3333333333334,
        color: "#6ec3c6",
      },
      {
        value: 688,
        color: "#56b0c8",
      },
      {
        value: 802.6666666666667,
        color: "#3c9cc7",
      },
      {
        value: 917.3333333333334,
        color: "#2282ba",
      },
      {
        value: 1032,
        color: "#0868ac",
      },
    ],
  },
  [RasterTypeEnum.INITIAL_WATERLEVEL_FILE]: {
    range: [-10, 0],
    stops: [
      {
        value: -10,
        color: "#f7fbff",
      },
      {
        value: -8.88888888888889,
        color: "#e2eef9",
      },
      {
        value: -7.777777777777778,
        color: "#cde0f2",
      },
      {
        value: -6.666666666666666,
        color: "#b0d2e8",
      },
      {
        value: -5.555555555555555,
        color: "#89bfdd",
      },
      {
        value: -4.444444444444445,
        color: "#60a6d2",
      },
      {
        value: -3.333333333333333,
        color: "#3e8ec4",
      },
      {
        value: -2.222222222222221,
        color: "#2172b6",
      },
      {
        value: -1.11111111111111,
        color: "#0a549e",
      },
      {
        value: 0,
        color: "#08306b",
      },
    ],
  },
  [RasterTypeEnum.INTERCEPTION_FILE]: {
    range: [-3.425, 16.9869995],
    stops: [
      {
        value: -3.4249999523163,
        color: "#ffffcc",
      },
      {
        value: -1.157000011867934,
        color: "#e4f4b6",
      },
      {
        value: 1.110999928580433,
        color: "#c9e99f",
      },
      {
        value: 3.3789998690288,
        color: "#a9dc8e",
      },
      {
        value: 5.646999809477165,
        color: "#88cd80",
      },
      {
        value: 7.914999749925531,
        color: "#68be71",
      },
      {
        value: 10.182999690373899,
        color: "#48af60",
      },
      {
        value: 12.450999630822265,
        color: "#2b9d51",
      },
      {
        value: 14.718999571270631,
        color: "#158244",
      },
      {
        value: 16.986999511719,
        color: "#006837",
      },
    ],
  },
  [RasterTypeEnum.MAX_INFILTRATION_CAPACITY_FILE]: {
    range: [0.015, 9999],
    stops: [
      {
        value: 0.0149999996647239,
        color: "#f1eef6",
      },
      {
        value: 1111.0133333330352,
        color: "#e6d5e9",
      },
      {
        value: 2222.0116666664057,
        color: "#dabcdc",
      },
      {
        value: 3333.0099999997765,
        color: "#da9acb",
      },
      {
        value: 4444.008333333147,
        color: "#de77b9",
      },
      {
        value: 5555.006666666517,
        color: "#df55a3",
      },
      {
        value: 6666.004999999888,
        color: "#de348a",
      },
      {
        value: 7777.0033333332585,
        color: "#d61871",
      },
      {
        value: 8888.001666666629,
        color: "#b70c5a",
      },
      {
        value: 9999,
        color: "#980043",
      },
    ],
  },
  [RasterTypeEnum.VEGETATION_DRAG_COEFFICIENT_FILE]: {
    range: [0, 10],
    stops: [
      {
        value: 0,
        color: "#fcfbfd",
      },
      {
        value: 2.5,
        color: "#dadaeb",
      },
      {
        value: 5,
        color: "#9e9ac8",
      },
      {
        value: 7.5,
        color: "#6a51a3",
      },
      {
        value: 10,
        color: "#3f007d",
      },
    ],
  },
  [RasterTypeEnum.VEGETATION_HEIGHT_FILE]: {
    range: [0, 2],
    stops: [
      {
        value: 0,
        color: "#f7fcf5",
      },
      {
        value: 0.5,
        color: "#c9eac2",
      },
      {
        value: 1,
        color: "#7bc77c",
      },
      {
        value: 1.5,
        color: "#2a924b",
      },
      {
        value: 2,
        color: "#00441b",
      },
    ],
  },
  [RasterTypeEnum.VEGETATION_STEM_COUNT_FILE]: {
    range: [0, 1000],
    stops: [
      {
        value: 0,
        color: "#feedde",
      },
      {
        value: 250,
        color: "#fdbe85",
      },
      {
        value: 500,
        color: "#fd8d3c",
      },
      {
        value: 750,
        color: "#e6550d",
      },
      {
        value: 1000,
        color: "#a63603",
      },
    ],
  },
  [RasterTypeEnum.VEGETATION_STEM_DIAMETER_FILE]: {
    range: [0, 0.1],
    stops: [
      {
        value: 0,
        color: "#ffffdf",
      },
      {
        value: 0.025,
        color: "#fff4a7",
      },
      {
        value: 0.05,
        color: "#ffe970",
      },
      {
        value: 0.075,
        color: "#ffdd38",
      },
      {
        value: 0.1,
        color: "#ffd200",
      },
    ],
  },
} as const;
